import Tool from "./Tool";
import Vector2 from "./Vector2";
import MouseEventArgs, { MouseButton } from "./MouseEventArgs";
import Editor from "./Editor";
import Camera from "./Camera";

const zoomScaleFactor = 0.0005;

export default class PanZoomTool extends Tool {
  private _dragging = false;
  private _startMousePos: Vector2 = null;
  private _startCameraPos: Vector2 = null;

  public constructor(editor: Editor) {
    super(editor, "pan_zoom");
  }

  public handleMouseDown(arg: MouseEventArgs): boolean {
    if (arg.button != MouseButton.Middle) {
      return false;
    }
    this._dragging = true;
    this._startMousePos = arg.screenPosition;
    this._startCameraPos = this.editor.camera.position;
    return true;
  }

  public handleMouseMove(arg: MouseEventArgs): boolean {
    if (this._dragging == false) {
      return false;
    }
    var pos = arg.screenPosition;

    var offset = pos.sub(this._startMousePos);
    var newCameraPos = this._startCameraPos.sub(
      offset.divScalar(this.editor.camera.scale)
    );

    this.editor.setCamera(new Camera(newCameraPos, this.editor.camera.scale));

    return true;
  }

  public handleMouseUp(arg: MouseEventArgs): boolean {
    if (this._dragging == false) {
      return false;
    }

    this._dragging = false;
    this._startMousePos = null;
    this._startCameraPos = null;
    return true;
  }

  public handleMouseWheel(args: MouseEventArgs): boolean {
    var camera = this.editor.camera;
    var finalScale =
      camera.scale - camera.scale * args.wheelDelta * zoomScaleFactor;
    finalScale = Math.max(finalScale, 0.1);

    var initialMousePosition = args.worldPosition;
    var zoomedCamera = new Camera(camera.position, finalScale);

    var finalMousePosition = zoomedCamera.transformPointScreenToWorld(
      args.screenPosition
    );

    var finalCameraPosition = zoomedCamera.position.add(
      initialMousePosition.sub(finalMousePosition)
    );

    this.editor.setCamera(new Camera(finalCameraPosition, finalScale));

    return true;
  }
}
